import { Component, inject, signal } from '@angular/core';
import { TitleComponent } from "../../shared/components/title-component/title-component";
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatSpinner } from '@angular/material/progress-spinner';
import { ToastrService } from '../../shared/services/toastr-service';
import { Compagnie, Collaborateur, ListItem, ModalListItemI, Partenaire } from '../../shared/model';
import { MatSelect, MatOption } from "@angular/material/select";
import { AuthService } from '../../auth/services/auth-service';
import { CompagnieService } from '../../compagnie/service/compagnie-service';
import { MatDialog } from '@angular/material/dialog';
import { ListModalComponent } from '../../shared/components/list-modal-component/list-modal-component';
import { PartenaireService } from '../service/partenaire-service';
import { SweetAlertService } from '../../shared/services/sweet-alert-service';
import { MatTooltip } from "@angular/material/tooltip";
import { DatabaseConnection } from '../../shared/services/database-connection';
import { CollaborateurService } from '../../collaborateur/service/collaborateur-service';

@Component({
  selector: 'app-distribution-component',
  imports: [
    TitleComponent,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatIcon,
    MatSelect,
    MatOption,
    MatTooltip,
    MatIcon
],
  templateUrl: './distribution-component.html',
  styleUrl: './distribution-component.css',
})
export class DistributionComponent {
  refControl : FormControl = new FormControl('')
  loading = signal<boolean>(false)
  loadingc = signal<boolean>(false)

  partenaire = signal<Partenaire>(new Partenaire())

  path = inject(DatabaseConnection).storageConnection.value

  compagnies = signal<Compagnie[]>([])
  currentCompagnieId : string = ""

  distForm : FormGroup = new FormGroup({})

  readonly dialog = inject(MatDialog);

  constructor(
    private collaborateurService : CollaborateurService,
    private toastr : ToastrService,
    private authservice : AuthService,
    private compagnieService : CompagnieService,
    private partenaireService : PartenaireService,
    private fb : FormBuilder,
    private sweetAlert : SweetAlertService
  ){

  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

    this.distForm = this.fb.group({
      type : ['', [Validators.required]],
      attestation_start : [{value : '', disabled : true}, [Validators.required]],
      attestation_end : [{value : '', disabled : true}, [Validators.required]],
      carte_rose_start : [{value : '', disabled : true}, [Validators.required]],
      carte_rose_end : [{value : '', disabled : true}, [Validators.required]],
      qte : [{value : '', disabled : true}, [Validators.required]]
    })

    this.compagnieService.getAll().subscribe((res) => this.compagnies.update(c => c = res))

    this.loadCollaborateur()
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    /*this.refControl.valueChanges.subscribe((res : string) =>{

      if(res.length >=4){
        console.log(123);
          this.loadCollaborateurData()
      }
    })*/

    this.distForm.get('qte')?.valueChanges.subscribe((val) =>{
      if(val != ''){
        if(this.distForm.get('attestation_start')?.value!=''){
          this.setAttestationEndValue()
        }

        if(this.distForm.get('carte_rose_start')?.value!=''){
          this.setCarteRoseEndValue()
        }
      }
    })
  }

  loadCollaborateur(){

      //this.currentCompagnieId = this.authservice.getCurrentUser().user.compagnie_id
      this.loading.update(val => true)
      //const code = (this.refControl.value as string).trim().toUpperCase()

      this.collaborateurService.getCollaborateurListEnable().subscribe({
        next : (res) => {
          /*this.refControl.setValue('')
          this.partenaire.update((p) => p = res)
          this.loading.update(val => false)
          this.refControl.setValue('')
          this.toastr.success('collaborateur : '+this.partenaire().collaborateur_name)*/
          this.openCollabModal(res.slice())
        },
        error : (err) =>{
          this.loading.update(val => false)
          this.toastr.error(err.error.message)
          this.partenaire.update(p => new Partenaire())
        }
      })

  }

  openCollabModal(partenaires : Partenaire[]){

    //this.partenaire.update((p) => p = new Partenaire())
    

    const dataList : ModalListItemI = {
      title : 'Collaborateurs',
      data : partenaires.map(item => {
        return {id : item.id, name : item.collaborateur_name+" / "+item.compagnie_name}
      })
    }

    const dialogRef = this.dialog.open(ListModalComponent, {
      width: '800px',
      height : '500px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : dataList
    });

    dialogRef.afterClosed().subscribe((res : ListItem) =>{
      
      if(res.id){
        const part = partenaires.find(item => item.id == res.id)
        this.partenaire.update(item => part!)
      }
    })
  }

  onShare(){
    const data = {
      type : this.distForm.get('type')?.value,
      attestation_range : this.distForm.get('attestation_start')?.value+"-"+(this.distForm.get('attestation_end')?.value),
      carte_rose_range : this.distForm.get('carte_rose_start')?.value+"-"+this.distForm.get('carte_rose_end')?.value,
      qte : this.distForm.get('qte')?.value,
      reste : this.distForm.get('qte')?.value,
      partenaire_id : this.partenaire().id
    }
    console.log(data);

    this.sweetAlert.confirm('Etez-vous sur de vouloir valider cette distribution ?')
    .then((res) =>{
      if(res.isConfirmed){
        this.partenaireService.share(data).subscribe({
          next : (res) =>{
            this.sweetAlert.success('Distribution effectue',2000)
            .then((res) =>{
              this.partenaire.update(p => p = new Partenaire())
              this.distForm.reset()
            })

          },
          error : (err) =>{
            this.toastr.error('Une erreur est survenue lors de la distribution')
          }
        })
      }
    })
  }



  setAttestationEndValue(){
    const endValue = (this.distForm.get('attestation_start')?.value + this.distForm.get('qte')?.value - 1 )
    this.distForm.get('attestation_end')?.setValue(endValue)
    //
    this.activeControl('carte_rose_start', 'attestation_start')
  }


  setCarteRoseEndValue(){
    const endValue = (this.distForm.get('carte_rose_start')?.value + this.distForm.get('qte')?.value - 1 )
    this.distForm.get('carte_rose_end')?.setValue(endValue)
  }

  activeControl(control : string, currentValue : string){

    if(this.distForm.get(control)?.disabled && currentValue!='')
      this.distForm.get(control)?.enable()
  }


}
